<template>
  <div
    class="absolute bg-secondary-gray p-2 rounded-md transition-all duration-700 transform"
    :class="classObj"
  >
    <svg class="text-green-300" width="22" height="22" viewBox="0 0 20 20" fill="currentColor">
      <slot />
    </svg>
  </div>
</template>

<script>
export default {
  name: "ContactFormSvgWrapper",
  props: ["active"],
  computed: {
    classObj: function () {
      return {
        "-translate-y-4 -translate-x-3 shadow-dark": this.active,
      };
    },
  },
};
</script>

<style scoped>
</style>
